
import React, { useState } from 'react';

import { useAgentStatus } from '../../hooks/useAgentStatus';
import { usePlanningRunFailure } from '../../hooks/usePlanningRunFailure';
import { useAppSelector } from '../../store/hooks';

import { ChatBoxLayout } from './ChatBoxLayout';
import { useChatBox } from './useChatBox';
import { useChatBoxTasks } from './useChatBoxTasks';

interface ChatBoxProps {
  projectId: string | null;
  sessionId?: string | null;
  initialProjectBootstrap?: boolean;
  title?: string;
  isReadOnly?: boolean;
  isSessionResolving?: boolean;
  sessionLoadFailed?: boolean;
}

export function ChatBox(props: ChatBoxProps): React.ReactElement {
  const chatState = useChatBox(props);
  const { activeAgents, isRunning } = useAgentStatus(props.projectId, chatState.activeSessionId);
  const planningFailure = usePlanningRunFailure(props.projectId, isRunning);
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const projectRole = useAppSelector((state) => (
    state.planning.activeProjectId === props.projectId ? state.planning.projectRole : null
  ));
  const { hasTodoTasks, todoTaskCount } = useChatBoxTasks(props.projectId);

  return (
    <ChatBoxLayout
      {...props}
      {...chatState}
      activeAgents={activeAgents}
      isPlanningRunning={isRunning}
      planningFailureMessage={planningFailure.message}
      onDismissPlanningFailure={planningFailure.dismiss}
      isLogModalOpen={isLogModalOpen}
      onOpenLogModal={() => setIsLogModalOpen(true)}
      onCloseLogModal={() => setIsLogModalOpen(false)}
      hasTodoTasks={hasTodoTasks}
      todoTaskCount={todoTaskCount}
      isReadOnly={props.isReadOnly ?? projectRole === 'reader'}
    />
  );
}
